import { OvalBadgeProps } from "./types"
import React from "react"
// import { StyleSheet } from "~/ui/primitives"
import styled from '~/ui/styled'
import { CenterFlex } from "~components/El"

const BadgeContainer = styled(CenterFlex)<OvalBadgeProps>`
height: auto;
width: auto;
  position: absolute;
  right: ${({ right }) => right};
  top: ${({ top }) => top};
  justify-content: center;
  align-items: center;
  padding: 2px;
  min-width: 18px;
  min-height: 18px;
  border-radius: 18px;
  background-color: ${({ backgroundColor, theme }) => backgroundColor || theme.colors.error};
  z-index: 1;
`

const BadgeText = styled.Text`
  color: #fff;
  font-size: 10px;
`

const OvalBadge: React.FC<OvalBadgeProps> = ({ value = 1, top = 5, right = 5, backgroundColor }) => {
  if (value <= 0) return null
  return (
    <BadgeContainer top={top} right={right} backgroundColor={backgroundColor}>
      <BadgeText>{value}</BadgeText>
    </BadgeContainer>
  )
}

export default OvalBadge
